<div class="logo">
  <a routerLink="/" class="simple-text">
    <img src="assets/img/logo-sidebar.png" alt="Logo do Codex">
    <br/>
    Codex
  </a>
</div>

<div class="sidebar-wrapper">
  <div class="carregando-menu" *ngIf="carregandoMenu">
    <i class="pi pi-spin pi-spinner" style="font-size: 3em"></i>
  </div>
  <ul class="nav" *ngIf="!carregandoMenu">
    <ng-container *ngFor="let menuItem of menuItems; let i = index">
      <li *ngIf="menuItem.visivel" routerLinkActive="active" [ngClass]="menuItem.class">
        <a [routerLink]="[menuItem.path]" *ngIf="!menuItem.items">
          <i class="{{ menuItem.icon }}"></i>
          <p>{{ menuItem.title }}</p>
        </a>
        <a class="cursor-pointer" (click)="abrirMenu(i)" *ngIf="menuItem.items && menuItem.items.length > 0">
          <i class="{{ menuItem.icon }}"></i>
          <p>{{ menuItem.title }}<b class="caret" [ngClass]="{ 'expanded': estaAberto(i) }"></b></p>
        </a>
        <div [ngClass]="{ 'menu-collapse': true, 'expanded': estaAberto(i) }" id="subMenu_{{ i }}">
          <ul class="nav">
            <ng-container *ngFor="let subItem of menuItem.items;">
              <li routerLinkActive="active">
                <a [routerLink]="[subItem.path]">
                  <span class="sidebar-mini">{{ subItem.initials }}</span>
                  <span class="sidebar-normal">{{ subItem.title }}</span>
                </a>
              </li>
            </ng-container>
          </ul>
        </div>
      </li>
    </ng-container>
  </ul>
</div>
